<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">Tabela de documentos comerciais</h3>
        </div>
        <!-- Page Header - Filters -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button
              type="button"
              class="btn btn-primary btn-sm mt-3"
              @click="OpenModalFilter()"
            >
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span v-if="countFilter > 0" class="badge badge-light">{{
                countFilter
              }}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Documentos comerciais</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6 class="m-0">
                  {{ pagination.TotalItems | number }}
                  {{ pagination.TotalItems > 1 ? " itens" : "item" }}
                </h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0">Código</th>
                    <th scope="col" class="border-0 text-left">Nome</th>
                    <th scope="col" class="border-0"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(merchantDocType, index) in merchantDocTypes"
                    :key="index"
                  >
                    <td></td>
                    <td>{{ merchantDocType.Code }}</td>
                    <td class="text-left">{{ merchantDocType.Name }}</td>
                    <td>
                      <div class="dropdown">
                        <button
                          class="btn btn-outline-secondary dropdown-toggle"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          Opções
                        </button>
                        <div
                          class="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            v-if="$isAuthorize('MerchantDocType', 'Get')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              OpenMerchantDocType($event, index, true)
                            "
                          >
                            <i class="fas fa-eye mr-2"></i> Visualizar
                          </a>
                          <a
                            v-if="$isAuthorize('MerchantDocType', 'Update')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="OpenMerchantDocType($event, index)"
                          >
                            <i class="fas fa-highlighter mr-2"></i> Editar
                          </a>
                          <a
                            v-if="$isAuthorize('MerchantDocType', 'Delete')"
                            class="dropdown-item"
                            href="#"
                            v-on:click="
                              ConfirmDeleteMerchantDocType($event, index)
                            "
                          >
                            <i class="fas fa-trash-alt mr-2"></i> Remover
                          </a>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr
                    v-if="
                      merchantDocTypes == undefined ||
                      merchantDocTypes == null ||
                      merchantDocTypes.length == 0
                    "
                  >
                    <td colspan="4">Sem registros</td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFormMerchantDocType"
      :title="modalTitle"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <loader :is-loading="loadingModal"></loader>

      <div v-if="!loadingModal">
        <ValidationObserver tag="form" ref="MerchantDocTypeValidationForm">
          <!-- Code -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Código</label>
              <ValidationProvider
                rules="required|min:1"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  :class="
                    validatedMerchantDocTypeForm | showValidateError(invalid)
                  "
                  v-model="infoMerchantDocType.Code"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedMerchantDocTypeForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
          <!-- Name -->
          <d-form-row>
            <d-col md="12" class="form-group">
              <label>Nome</label>
              <ValidationProvider
                rules="required|min:3"
                v-slot="{ errors, invalid }"
              >
                <d-form-input
                  type="text"
                  :class="
                    validatedMerchantDocTypeForm | showValidateError(invalid)
                  "
                  v-model="infoMerchantDocType.Name"
                  :disabled="isSeeing"
                />
                <div
                  class="invalid-feedback d-block"
                  v-if="validatedMerchantDocTypeForm"
                >
                  {{ errors[0] }}
                </div>
              </ValidationProvider>
            </d-col>
          </d-form-row>
        </ValidationObserver>
      </div>

      <template slot="modal-footer" slot-scope="{ cancel }">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="cancel()">Fechar</b-button>
        <b-button
          size="sm"
          variant="success"
          @click="SaveMerchantDocType()"
          v-if="!isSeeing || (isSeeing && loadingAddUpdate)"
          :disabled="loadingAddUpdate || loadingModal"
        >
          <template v-if="!loadingAddUpdate">
            {{ pOpened != null ? " Salvar" : " Adicionar" }}
            <i class="fas fa-arrow-right"></i>
          </template>
          <template v-else>
            <loader :small="true" :isLoading="loadingAddUpdate"></loader>
          </template>
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="6" class="form-group">
          <input
            placeholder="Código"
            type="text"
            class="form-control"
            v-model="filter.Code"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
        <d-col md="6" class="form-group">
          <input
            placeholder="Nome"
            type="text"
            class="form-control"
            v-model="filter.Name"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>

      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>

    <a
      v-if="$isAuthorize('MerchantDocType', 'Add')"
      href="#"
      class="btn-float success"
      v-b-tooltip.hover
      title="Novo documento comercial"
      v-on:click="OpenMerchantDocType($event)"
    >
      <i class="fa fa-plus"></i>
    </a>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "merchantDocType",
  data: function () {
    return {
      loadingList: false,
      loadingModal: false,
      loadingAddUpdate: false,
      countFilter: 0,
      modalTitle: "Novo documento comercial",
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0,
      },
      filter: {
        Code: null,
        Name: null,
      },
      idMerchantDocType: 0,
      pOpened: null,
      merchantDocTypes: [],
      infoMerchantDocType: {
        Code: null,
        Name: null,
      },
      isSeeing: false,
      validatedMerchantDocTypeForm: false,
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function () {
      this.ListMerchantDocType();
    },
    "pagination.RowsPerPage": function () {
      this.ListMerchantDocType();
    },
  },
  mounted() {
    this.ListMerchantDocType();
  },
  methods: {
    OpenModalFilter: function () {
      this.$bvModal.show("mFilter");
    },
    Filter: function () {
      this.$bvModal.hide("mFilter");
      this.ListMerchantDocType();
    },
    OpenMerchantDocType: function (e, i, view) {
      e.preventDefault();
      this.validatedMerchantDocTypeForm = false;
      this.loadingAddUpdate = false;
      this.ResetInfoMerchantDocType();

      if (view == undefined && i != undefined) {
        // Edit
        this.pOpened = i;
        this.idMerchantDocType = this.merchantDocTypes[i].Id;
        this.isSeeing = false;
        this.modalTitle = "Editar documento comercial";
        this.GetMerchantDocType();
      } else if (view == undefined && i == undefined) {
        // Add new
        this.pOpened = null;
        this.ResetInfoMerchantDocType;
        this.isSeeing = false;
        this.modalTitle = "Novo documento comercial";
        this.ResetInfoMerchantDocType();
      } else {
        // View
        this.pOpened = i;
        this.idMerchantDocType = this.merchantDocTypes[i].Id;
        this.isSeeing = true;
        this.modalTitle = "Detalhes do documento comercial";
        this.GetMerchantDocType();
      }
      this.$bvModal.show("mFormMerchantDocType");
    },
    ResetInfoMerchantDocType: function () {
      this.infoMerchantDocType = {
        Code: null,
        Name: null,
      };
    },
    SaveMerchantDocType: function () {
      this.validatedMerchantDocTypeForm = true;

      this.$refs.MerchantDocTypeValidationForm.validate().then((isValid) => {
        if (isValid) {
          this.loadingAddUpdate = true;
          this.isSeeing = true;
          if (this.pOpened == null) {
            // Add
            this.$store
              .dispatch("AddMerchantDocType", this.infoMerchantDocType)
              .then(() => {
                this.$makeToast(
                  "O documento comercial foi cadastrado corretamente na base de dados",
                  "success",
                  "Documento comercial"
                );
                this.ListMerchantDocType();
                this.$bvModal.hide("mFormMerchantDocType");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao criar o documento comercial",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          } else {
            // Update
            this.$store
              .dispatch("UpdateMerchantDocType", this.infoMerchantDocType)
              .then(() => {
                this.$makeToast(
                  "Suas modificações foram salvas na base de dados",
                  "success",
                  "Documento comercial"
                );
                this.ListMerchantDocType();
                this.$bvModal.hide("mFormMerchantDocType");
              })
              .catch((error) => {
                this.$makeToast(
                  undefined,
                  "danger",
                  "Erro ao atualizar o documento comercial",
                  error
                );
              })
              .finally(() => {
                this.loadingAddUpdate = false;
                this.isSeeing = false;
              });
          }
        }
      });
    },
    GetMerchantDocType: function () {
      if (this.idMerchantDocType != 0) {
        this.loadingModal = true;
        this.$store
          .dispatch("GetMerchantDocType", { id: this.idMerchantDocType })
          .then((response) => {
            this.infoMerchantDocType = response;
          })
          .catch((error) => {
            this.$makeToast(
              undefined,
              "danger",
              "Erro ao buscar o documento comercial",
              error
            );
          })
          .finally(() => {
            this.loadingModal = false;
          });
      }
    },
    ListMerchantDocType: function () {
      this.countFilter = 0;
      if (hasValue(this.filter.Code)) this.countFilter++;
      if (hasValue(this.filter.Name)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Code": this.filter.Code,
          "Object.Name": this.filter.Name,
        },
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListMerchantDocType", { params: data })
        .then((response) => {
          this.merchantDocTypes = response.Objects;
          this.pagination.TotalItems = response.TotalItems;
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao listar os documentos comerciais",
            error
          );
        })
        .finally(() => (this.loadingList = false));
    },
    ResetFilter: function () {
      this.filter = {
        Code: null,
        Name: null,
      };
      this.ListMerchantDocType();
    },
    ConfirmDeleteMerchantDocType: function (e, i) {
      e.preventDefault();
      let deleted = this.merchantDocTypes[i];
      this.$makeMsgBox(
        `Você tem certeza que deseja remover ${deleted.Name}?`,
        "Confirmar",
        this.DeleteMerchantDocType,
        i
      );
    },
    DeleteMerchantDocType: function (i) {
      let deleted = this.merchantDocTypes[i];
      this.$store
        .dispatch("DeleteMerchantDocType", { id: deleted.Id })
        .then(() => {
          this.$makeToast(
            `${deleted.Name} foi removido da sua lista de documentos comerciais`,
            "success",
            "Documento comerciais"
          );
          this.ListMerchantDocType();
          this.$bvModal.hide("mFormMerchantDocType");
        })
        .catch((error) => {
          this.$makeToast(
            undefined,
            "danger",
            "Erro ao remover o documento comercial",
            error
          );
        });
    },
  },
};
</script>

<style scoped>
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/merchantDocType.vue